import { connect } from 'react-redux';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { BADGE_ACTIVITY_STREAM } from '../../../streams';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getModuleDataByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';

export default connect(
  (state: AppState, ownProps) => {
    const { badges } = getModuleDataByModuleType(state, ModuleType.ABOUT);
    const { totalReceived, totalSent } = getModuleDataByModuleType(
      state,
      ModuleType.BADGES_ACTIVITY
    );
    return {
      currentUser: getCurrentUser(state),
      profileOwnerUser: getProfileOwnerUser(state),
      isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
      badges,
      badgeActivity: streamSelectors.getItems(state, BADGE_ACTIVITY_STREAM),
      hasMoreBadgeActivity: streamSelectors.hasMore(
        state,
        BADGE_ACTIVITY_STREAM
      ),
      isFetchingBadgeActivity: streamSelectors.isFetching(
        state,
        BADGE_ACTIVITY_STREAM
      ),
      isEmpty: !badges.length,
      totalReceived,
      totalSent,
    };
  },
  dispatch => ({
    fetchMoreBadgeActivity: () =>
      dispatch(withOffset.actions.fetch(BADGE_ACTIVITY_STREAM)),
  })
);
